import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AboutUs from "./Pages/Misc/About";
import Acknowledgement from "./Pages/Misc/Acknowledgement";
import AlumniCorner from "./Pages/Experiences/Alumni";
import AlumnusPartnership from "./Pages/Experiences/Alumni/Partnerships";
import Assessment from "./Pages/Offers/Assessment";
import Scalecamps from "./Pages/BannerItems/Pages/Scalecamp";
import Certificate from "./Pages/Certificates";
import ContactUs from "./Pages/Misc/Pages/ContactUs";
import Contribute from "./Pages/Misc/Pages/Contribute";
import Experiences from "./Pages/Experiences/";
import EventsList from "./Pages/Experiences/Events";
import Elements from "./Pages/Elements";
import Faq from "./Pages/Misc/Faqs";
import GersModel from "./Pages/GERSModel";
import GlobalGERS from "./Pages/GERSModel/GlobalGERS";
import Home from "./Pages/Home";
import License from "./Pages/Misc/License";
import NoMatch from "./Pages/Misc/NoMatch";
import Principles from "./Pages/Principles";
import Projects from "./Pages/BannerItems/Projects";
import OurPeople from "./Pages/Misc/OurPeople";
import Reviewers from "./Pages/Experiences/Reviewers";
import Services from "./Pages/BannerItems";
import DisplayTiki from "./Pages/Misc/DisplayTiki";
import InvestmentPage from "./Pages/Misc/Pages/Investment";
import MachineLearningPage from "./Pages/Misc/Pages/MachineLearning";
import MediaPage from "./Pages/Misc/Pages/Media";
import JoinusPage from "./Pages/Misc/Pages/Joinus";
import PrinciplesSearch from "./Pages/Principles/Search";

import './App.css';


class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/about-us" component={AboutUs} />
            <Route path="/acknowledgement" component={Acknowledgement} />
            <Route path="/alumni" component={AlumniCorner} />
            <Route path="/assess" component={Assessment} />
            <Route path="/scalecamps" component={Scalecamps} />
            <Route path="/calls-for-partnership" component={AlumnusPartnership} />            
            <Route path="/certificate/:name" component={Certificate} />
            <Route path="/contact-us" component={ContactUs} />
            <Route path="/contribute" component={Contribute} />
            <Route path="/elements/:id" component={Elements} />
            <Route exact path="/experiences" component={EventsList} />
            <Route path="/experiences/:experience" component={Experiences} />
            <Route path="/faq" component={Faq} />
            <Route path="/gers-model" component={GersModel} />
            <Route path="/global" component={GlobalGERS} />
            <Route path="/investment" component={InvestmentPage} />
            <Route path="/in-the-media" component={MediaPage} />
            <Route path="/joinus" component={JoinusPage} />
            <Route path="/license" component={License} />
            <Route path="/machine-learning" component={MachineLearningPage} />
            <Route path="/our-people" component={OurPeople} />
            <Route path="/principles" component={Principles} />
            <Route path="/principles-search" component={PrinciplesSearch} />
            <Route path="/reviewers" component={Reviewers} />
            <Route path="/services/projects/:item" component={Projects} />
            <Route path="/tiki" component={DisplayTiki} />
            <Route exact path="/:type" component={Services} />
            <Route component={NoMatch} />
          </Switch>
        </Router>
      </div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js